// Put your Javascript here - You can use ES2015 Javascript, because we use Webpack with Babel
require('./../Sass/base.scss');

// Require babel polyfill before anything else so stupid IE can handle modern stuff like Symbols etc.
if (!(global as any)._babelPolyfill) {
	require('babel-polyfill');
}

import {initImprint} from "../../../Assets/Js/VXImprint";
import * as helper from "../../../Assets/Js/helper";
import {loadFontAwesomeIcons} from "./Fontawesomeloader";
import {initMobileMenu} from "../../../Assets/Js/VXProductLight/MobileMenu";
import {PaytourHandler} from "./PaytourHandler";
import {initCookieBanner} from "../../../Assets/Js/VXProductLight/CookieBanner";

helper.onDocumentLoaded(() => {
	const impressumLink = helper.$('#impressumlink');
	const datenschutzLink = helper.$('#datenschutzlink');

	loadFontAwesomeIcons();
	initImprint(impressumLink, datenschutzLink);
	initMobileMenu();
	PaytourHandler();
	initCookieBanner();
})
